import React from 'react'
import './App.css';
import { Tab,Segment,Input,Button,Dropdown } from 'semantic-ui-react'

class Filters extends React.Component{
    
    constructor(props){
        super();
        this.state = {
            states:[],
            districts:[],
            selFilter:props.filter,
            selState: props.state,
            selDistrict: props.district,
            selStateName:props.stateName,
            selDistrictName:props.districtName,
            pin:props.pin,
        }
    }
    
    panes = [
      {
        menuItem: 'Search using Pincode',
        render: () => {
            return(
                <Tab.Pane attached={false}>
                    <Segment.Group compact>
                  <Segment>  
                      <Input id="pin" type="text" name="pin" placeholder="City pin"></Input>
                  </Segment>
                  <Segment vertical>
                      <Button onClick={this.inputChange} data-filter="pincode" color="green">Search</Button>
                  </Segment>
                  </Segment.Group>
                </Tab.Pane>
            )
        },
      },
      {
        menuItem: 'Search using District',
        render: () => {
            return(
                <Tab.Pane attached={false}>
                    <Segment.Group compact>
                  <Segment>  
                    <Dropdown
                        button
                        className='icon'
                        floating
                        labeled
                        icon='map'
                        options={this.state.states}
                        search
                        placeholder='Select State'
                        onChange={this.stateSelected}
                        value={this.state.selState}
                        text={this.state.selStateName}
                    />
                    <Dropdown
                        button
                        className='icon'
                        floating
                        labeled
                        icon='map marker'
                        options={this.state.districts}
                        search
                        placeholder='Select District'
                        onChange={this.districtSelected}
                        value={this.state.selDistrict}
                        text={this.state.selDistrictName}
                    />
                  </Segment>
                  <Segment vertical>
                      <Button onClick={this.inputChange} data-filter="district" color="green">Search</Button>
                  </Segment>
                  </Segment.Group>
                </Tab.Pane>
            )
        },
      },
      {
        menuItem: 'Filters',
        render: () => {
            return(
                <Tab.Pane attached={false}>
                    <Segment.Group compact>
                  <Segment>
                  <Dropdown
                        placeholder={this.props.appState.ageFilter !=="" ? this.props.appState.ageFilter : 'Age group'}
                        icon='filter'
                        floating
                        labeled
                        button
                        className='icon'
                    >
                        <Dropdown.Menu>
                          <Dropdown.Header icon='tags' content='Filter by Age group' />
                          <Dropdown.Divider />
                          <Dropdown.Item onClick={()=>{this.props.setState.isAgeFilter(false);this.props.setState.ageFilter("All")}} icon='users' text='All' value="all" />
                          <Dropdown.Item onClick={()=>{this.props.setState.ageFilter("18+");this.props.setState.isAgeFilter(true)}} icon='child' text='18-44' value="18+" />
                          <Dropdown.Item onClick={()=>{this.props.setState.ageFilter("44+");this.props.setState.isAgeFilter(true)}} icon='male' text='44+' value="44+"/>
                        </Dropdown.Menu>
                    </Dropdown>
                  <Dropdown
                        placeholder={this.props.appState.feeFilter !=="" ? this.props.appState.feeFilter : 'Fees'}
                        icon='filter'
                        floating
                        labeled
                        button
                        className='icon'
                    >
                        <Dropdown.Menu>
                          <Dropdown.Header icon='tags' content='Filter by fees' />
                          <Dropdown.Divider />
                          <Dropdown.Item onClick={()=>{this.props.setState.isFeeFilter(false);this.props.setState.feeFilter("All")}} icon="check circle" text='All' value="all" />
                          <Dropdown.Item onClick={()=>{this.props.setState.feeFilter("free");this.props.setState.isFeeFilter(true)}} icon='check' text='Free' value="free" />
                          <Dropdown.Item onClick={()=>{this.props.setState.feeFilter("paid");this.props.setState.isFeeFilter(true)}} icon='money' text='Paid' value="paid"/>
                        </Dropdown.Menu>
                    </Dropdown>
                  <Dropdown
                        placeholder={this.props.appState.vaccineFilter !=="" ? this.props.appState.vaccineFilter : 'Vaccine'}
                        icon='filter'
                        floating
                        labeled
                        button
                        className='icon'
                    >
                        <Dropdown.Menu>
                          <Dropdown.Header icon='tags' content='Filter by Vaccine Name' />
                          <Dropdown.Divider />
                          <Dropdown.Item onClick={()=>{this.props.setState.isVaccineFilter(false);this.props.setState.vaccineFilter("All")}} icon="check circle" text='All' value="all" />
                          <Dropdown.Item onClick={()=>{this.props.setState.vaccineFilter("COVISHIELD");this.props.setState.isVaccineFilter(true)}} icon='syringe' text='Covishield' value="COVISHIELD" />
                          <Dropdown.Item onClick={()=>{this.props.setState.vaccineFilter("COVAXIN");this.props.setState.isVaccineFilter(true)}} icon='syringe' text='Covaxin' value="COVAXIN"/>
                          <Dropdown.Item onClick={()=>{this.props.setState.vaccineFilter("SPUTNIK V");this.props.setState.isVaccineFilter(true)}} icon='syringe' text='Sputnik V' value="SPUTNIK V"/>
                        </Dropdown.Menu>
                    </Dropdown>
                  </Segment>
                  <Segment>
                    <Button color="red" 
                      onClick={()=>{
                        this.props.setState.isFeeFilter(false);
                        this.props.setState.isAgeFilter(false);
                        this.props.setState.isVaccineFilter(false);
                        this.props.setState.feeFilter("");
                        this.props.setState.ageFilter("");
                        this.props.setState.vaccineFilter("");
                      }}
                    >
                      Clear Filters</Button>
                  </Segment>
                  </Segment.Group>
                </Tab.Pane>
            )
        },
      },
    ]

    fetchStates = async () =>{
        await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/states`,{
            method:"GET",
          })
          .then(response => response.json())
          .then(json => {
              let states = json["states"].map((state)=>{
                return {key:state["state_name"],text:state["state_name"],value:state["state_id"]}
              });
              this.setState({states:states});
            })
          .catch(e=>console.log("unable to fetch States !, trying again ..."));
    }

    fetchDistricts = async (state_id) =>{
        await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/districts/${state_id}`,{
            method:"GET",
          })
          .then(response => response.json())
          .then(json => {
              let districts = json["districts"].map((district)=>{
                return {key:district["district_name"],text:district["district_name"],value:district["district_id"]}
              });
              this.setState({districts:districts});
            })
          .catch(e=>console.log(e));
    }

    stateSelected = (e,data) => {
      e.preventDefault();
      this.setState({selState:data.value});
      this.setState({selStateName:e.target.textContent});
      this.fetchDistricts(data.value);

      localStorage.setItem("state",data.value);
      this.props.setState["state"](data.value);
      localStorage.setItem("stateName",e.target.textContent);
      this.props.setState["stateName"](e.target.textContent);
    }

    districtSelected = (e,data) => {
      e.preventDefault();
      this.setState({selDistrict:data.value});
      this.setState({selDistrictName:e.target.textContent});

      localStorage.setItem("district",data.value);
      this.props.setState["district"](data.value);
      localStorage.setItem("districtName",e.target.textContent);
      this.props.setState["districtName"](e.target.textContent);
    }

    tabChange = (e,data)=>{
      if(data.activeIndex === 0){
        this.props.setState["filter"]("pincode");
        this.setState({selFilter:"pincode"})
        localStorage.setItem("filter","pincode");
      }else if(data.activeIndex === 1){
        this.props.setState["filter"]("district");
        this.setState({selFilter:"district"});
        localStorage.setItem("filter","district");
      }
    }

    inputChange = (e) =>{
      e.preventDefault();
      if(e.target.dataset.filter==="pincode"){
        let pin = document.querySelector("#pin").value;
        this.props.setState["pin"](pin);
        this.setState({pin:pin});
        localStorage.setItem("pin",pin);
      }
      this.props.fetchData();
    }

    componentDidUpdate(){
      if(document.querySelector("#pin") && document.querySelector("#pin") !== document.activeElement)
        document.querySelector("#pin").value = this.state.pin;
    }
    
    componentDidMount(){
      this.fetchStates();
      if(document.querySelector("#pin"))
        document.querySelector("#pin").value = this.state.pin;
    }

    render(){
        return (<Tab 
                  menu={{ pointing: true }} 
                  panes={this.panes} 
                  className="tabs" 
                  onTabChange={this.tabChange}
                  // activeIndex={()=>if(this.state.selFilter === "district") 1}
                  renderActiveOnly={true}
                />);
    }
}

export default Filters;